import * as React from 'react';
import { AbsenceListData } from '../types';

type Props = {
  data: AbsenceListData;
};

const AbsenceListWidget: React.FC<Props> = ({ data }) => {
  if (data.items.length === 0) {
    return null;
  }
  return (
    <div className="ai-chat-widget ai-chat-widget-absence-list">
      {data.items.map((item, idx) => (
        <div key={idx} className="ai-chat-widget-absence-list-row">
          <div className="ai-chat-widget-absence-list-main">
            <span className="ai-chat-widget-absence-list-category">
              {item.category}
            </span>
            <span className="ai-chat-widget-absence-list-date">
              {item.dateLabel}
            </span>
          </div>
          <span
            className={`ai-chat-widget-status-pill ai-chat-widget-status-pill--${item.status}`}>
            {item.statusLabel}
          </span>
        </div>
      ))}
    </div>
  );
};

export default AbsenceListWidget;
